module.exports = __webpack_public_path__ + "static/media/save.da402f0c.svg";